import { clone, onError } from '../../common/common';
import { getLabels } from './common';
import { checkHeaderStatus } from '../../design/routes/common/modules/header';
import { refreshProjectMoodboard } from '../../design/actions/moodboard';
import ChatApi from '../../design/api/chat-api';

// ------------------------------------
// Constants
// ------------------------------------
export const CHAT_UPDATE_MESSAGE = 'CHAT_UPDATE_MESSAGE';
export const CHAT_SEND_MESSAGE = 'CHAT_SEND_MESSAGE';
export const CHAT_SEND_MESSAGE_PROGRESS = 'CHAT_SEND_MESSAGE_PROGRESS';
export const CHAT_SEND_MESSAGE_ERROR = 'CHAT_SEND_MESSAGE_ERROR';
export const CHAT_APPLY_MESSAGE = 'CHAT_APPLY_MESSAGE';
export const CHAT_ADD_IMAGE = 'CHAT_ADD_IMAGE';
export const CHAT_REMOVE_IMAGE = 'CHAT_REMOVE_IMAGE';

// ------------------------------------
// Actions
// ------------------------------------

export const updateMessage = text => {
  return { type: CHAT_UPDATE_MESSAGE, payload: { text } };
};

export const sendMessage = (chatId, message, role) => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      const { sending, text, images, files } = message;
      if (!sending && (text || (images && images.length > 0))) {
        const onSuccessFn = data => {
          dispatch({ type: CHAT_APPLY_MESSAGE, payload: { id: message.id, message: data } });
          const workdesk = getState().workdesk;
          const project = workdesk ? workdesk.project : null;
          if (project) dispatch(refreshProjectMoodboard(project));
        };

        const onErrorFn = response => {
          dispatch({ type: CHAT_SEND_MESSAGE_ERROR, payload: { error: response } });
          onError(response);
        };

        const onProgressFn = progress => {
          dispatch({ type: CHAT_SEND_MESSAGE_PROGRESS, payload: { progress } });
        };

        dispatch({ type: CHAT_SEND_MESSAGE, payload: { role, chatId, message } });
        ChatApi.sendMessage(chatId, text, role, files, onSuccessFn, onErrorFn, onProgressFn);
      }
      resolve();
    });
  };
};

export const addImages = fileInput => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      for (let i = 0; i < fileInput.files.length; i++) {
        let file = fileInput.files[i];
        let class_name = file.type.match(/^image/i) ? 'Image' : 'Document';
        let reader = new FileReader();
        reader.onloadend = () => {
          dispatch({
            type: CHAT_ADD_IMAGE,
            payload: { url: reader.result, filename: file.name, file, class_name },
          });
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      }

      resolve();
    });
  };
};

export const removeImage = index => {
  return { type: CHAT_REMOVE_IMAGE, payload: { index } };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processUpdate = (state, action) => {
  return clone(state, { message: { ...state.message, text: action.payload.text } });
};

const processSend = (state, action) => {
  let newState = clone(state);
  newState.message = { ...state.message, sending: true, error: false, progress: 0 };
  return newState;
};

const processSendingProgress = (state, action) => {
  let newState = clone(state);
  newState.message = { ...state.message, progress: action.payload.progress };
  return newState;
};

const processError = (state, action) => {
  let newState = clone(state);
  newState.message = { ...state.message, error: true, sending: false };
  return newState;
};

const processApply = (state, action) => {
  const newState = clone(state);
  newState.message = { text: '', id: newState.message.id - 1, images: [], files: [] };
  return newState;
};

const processAddImage = (state, action) => {
  let payload = action.payload;
  let newState = clone(state);
  newState.message.images.push({
    url: payload.url,
    class_name: payload.class_name,
    filename: payload.filename,
  });
  newState.message.files.push(action.payload.file);
  return newState;
};

const processRemoveImage = (state, action) => {
  let newState = clone(state);
  newState.message.images.splice(action.payload.index, 1);
  newState.message.files.splice(action.payload.index, 1);
  return newState;
};

export const NEW_MESSAGE_ACTION_HANDLERS = {
  [CHAT_UPDATE_MESSAGE]: processUpdate,
  [CHAT_SEND_MESSAGE]: processSend,
  [CHAT_SEND_MESSAGE_PROGRESS]: processSendingProgress,
  [CHAT_SEND_MESSAGE_ERROR]: processError,
  [CHAT_APPLY_MESSAGE]: processApply,
  [CHAT_ADD_IMAGE]: processAddImage,
  [CHAT_REMOVE_IMAGE]: processRemoveImage,
};



// WEBPACK FOOTER //
// ./app/javascript/chat/modules/new-message.js